import { MiddlewareKey, InternalAxiosRequestConfig } from 'axios';

export const isMiddlewareUsed = (
  middleware: MiddlewareKey,
  config?: InternalAxiosRequestConfig
) => !config?.middlewares || config.middlewares.includes(middleware);
